/**
 * Plantillas de primer contacto con desarrolladoras (canal B2B). El comercial
 * elige la desarrolladora en su ficha y el sistema arma el mensaje —WhatsApp o
 * mail— con el nombre de la desarrolladora y del agente, para copiar y enviar
 * junto con el folleto elegido. Textos provistos por el equipo comercial.
 */

const rellenar = (t, { desarrolladora, agente }) =>
  t.replaceAll("{desarrolladora}", desarrolladora || "el estudio")
   .replaceAll("{agente}", agente || "el equipo de Habitia");

const WHATSAPP = `Hola! Mi nombre es {agente}, soy agente comercial de Habitia.
Les escribo porque trabajamos con desarrolladoras ayudándolas a que sus edificios se entreguen ya funcionando, con la administración resuelta desde el día uno: gastos comunes, pagos, incidencias y comunicación con los propietarios, todo en una sola plataforma con IA.
Les comparto un folleto breve con más detalle y si les interesa, coordinamos una llamada corta para ver cómo podría sumar Habitia a los próximos proyectos de {desarrolladora}.`;

const MAIL_ASUNTO = `Habitia · administración con IA para los próximos proyectos de {desarrolladora}`;

const MAIL_CUERPO = `Hola, equipo de {desarrolladora},
Mi nombre es {agente} y soy agente comercial de Habitia: la plataforma con inteligencia artificial que moderniza la administración de edificios desde el momento en que se entregan.
Les escribo porque creemos que Habitia puede sumar valor a los próximos proyectos del estudio: nuestros edificios se entregan ya administrados, sin transición ni planillas, y cada propietario tiene su propia app para gastos comunes, avisos y reservas. Eso se traduce en menos problemas de posventa y compradores más tranquilos desde el primer día.
Les adjunto un breve material con el detalle de cómo funciona. Si les interesa, me encantaría coordinar una reunión corta para conversar sobre cuánto podría aportar a sus próximos desarrollos.

Saludos,
{firma}`;

/** Bloque de firma del comercial para el mail: nombre + cargo + contacto. */
function firmaBlock({ agente, cargo, tel, email }) {
  const lines = [agente || "el equipo de Habitia", `${cargo || "Agente Comercial"} · Habitia`];
  if (tel) lines.push(tel);
  if (email) lines.push(email);
  return lines.join("\n");
}

/** Mensaje de WhatsApp listo (texto plano). */
export function plantillaWhatsapp(vars) {
  return rellenar(WHATSAPP, vars);
}

/**
 * Mail listo: { asunto, cuerpo }. `contacto` (opcional) arma la firma del comercial
 * al pie (cargo, teléfono, email); si no viene, la firma es sólo nombre · Habitia.
 */
export function plantillaMail(vars, contacto = {}) {
  const firma = firmaBlock({ agente: vars.agente, cargo: contacto.cargo, tel: contacto.tel, email: contacto.email });
  const cuerpo = rellenar(MAIL_CUERPO.replaceAll("{firma}", firma), vars);
  return { asunto: rellenar(MAIL_ASUNTO, vars), cuerpo };
}
